import { create } from 'zustand';

const useThemeStore = create((set) => ({
  isDarkMode: false,
  toggleTheme: () => {
    set((state) => {
      const newTheme = !state.isDarkMode;
      localStorage.setItem('theme', newTheme ? 'light' : 'light');
      document.documentElement.classList.toggle('light', newTheme);
      return { isDarkMode: newTheme };
    });
  },
}));

export default useThemeStore; 